module.exports = __webpack_public_path__ + "ninja.svg?30dd84fe66f3978bdc60a9823a6f04af";